// A deploy replaces every content-hashed file under /static, so a tab that has
// been open since before the deploy still asks webpack for chunk names that no
// longer exist. The lazy import then rejects with a ChunkLoadError and takes
// down the tree. The only recovery is a full reload to pick up the new
// index.html and its chunk manifest.

const RELOAD_KEY = "rs-chunk-reload-at";
const RELOAD_COOLDOWN_MS = 20000;

const CHUNK_ERROR_PATTERN =
  /Loading (CSS )?chunk .+ failed|Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed/i;

export const isChunkLoadError = (err) => {
  if (!err) return false;
  if (err.name === "ChunkLoadError") return true;
  return CHUNK_ERROR_PATTERN.test(err.message || "");
};

// Reloads once, then backs off. Without the guard a chunk that is genuinely
// missing (bad build, blocked by a proxy) would put the tab in a reload loop.
export const reloadForNewBuild = () => {
  let lastReload = 0;
  try {
    lastReload = Number(window.sessionStorage.getItem(RELOAD_KEY)) || 0;
  } catch (e) {
    // sessionStorage can throw in private/blocked-storage modes
  }

  if (Date.now() - lastReload < RELOAD_COOLDOWN_MS) return false;

  try {
    window.sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
  } catch (e) {
    // ignore
  }

  window.location.reload();
  return true;
};
